<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1914535937
     */
    const props = defineProps<IWidgetProps<MemberHighlightData>>();
    const { cmsComponentProps } = useWidget(props);
</script>

<template>
    <mol-member-highlight v-bind="cmsComponentProps" />
</template>
